"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BtnCheckout = /** @class */ (function () {
    function BtnCheckout() {
        this.config = {
            nodeLists: {
                main: null
            },
            selectors: {
                main: '[data-btn-checkout]'
            },
            classNames: {
                loading: 'btn--loading'
            }
        };
    }
    BtnCheckout.prototype.init = function () {
        this.config.nodeLists.main = document.querySelectorAll(this.config.selectors.main);
    };
    BtnCheckout.prototype.loading = function () {
        var _this = this;
        this.config.nodeLists.main.forEach(function (htmlElement) {
            htmlElement.classList.add(_this.config.classNames.loading);
        });
    };
    BtnCheckout.prototype.loaded = function () {
        var _this = this;
        this.config.nodeLists.main.forEach(function (htmlElement) {
            htmlElement.classList.remove(_this.config.classNames.loading);
        });
    };
    return BtnCheckout;
}());
exports.default = new BtnCheckout();
